export default __webpack_public_path__ + "static/SRUS 1360PW - Product Specifications & Technical Data-67a85b9a90f6e6db2f904df0417eaa82.pdf";